import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/login/callback")({
  beforeLoad: () => {
    throw redirect({ to: "/" });
  },
  component: () => null,
});
